import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {ImageModalComponent} from '@shared/components/image-modal/image-modal.component';
import {DialogService} from "@shared/services/dialog.service";

import {HandoverModel} from "@handover/view-models/handover.model";
import {HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";

@Component({
    selector: 'handoverm-handover-section',
    templateUrl: './handover-section.component.html',
    styleUrls: ['./handover-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverSectionComponent implements OnInit {

    @Input() desc? = '';
    @Input() images?: string[] = [];
    @Input() model?: HandoverModel;

    get isImagesVisible(): boolean {
        return this.images != null && this.images?.length > 0;
    }

    constructor(
        private dialogService: DialogService,
        private handoverNotificationsService: HandoverNotificationsService) {
    }

    ngOnInit(): void {
    }

    openImage(image: string) {
        this.dialogService.open(ImageModalComponent, image);
    }

    onImageLoaded() {
        this.model!.allImagesCount--;
        if (this.model?.allImagesCount === 0) {
            this.handoverNotificationsService.handoverImagesLoaded$.next(true);
        }
    }
}
